import { render, staticRenderFns } from "./online_complaints.vue?vue&type=template&id=b014c45c&scoped=true"
import script from "./online_complaints.vue?vue&type=script&lang=js"
export * from "./online_complaints.vue?vue&type=script&lang=js"
import style0 from "./online_complaints.vue?vue&type=style&index=0&id=b014c45c&lang=scss"
import style1 from "./online_complaints.vue?vue&type=style&index=1&id=b014c45c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b014c45c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b014c45c')) {
      api.createRecord('b014c45c', component.options)
    } else {
      api.reload('b014c45c', component.options)
    }
    module.hot.accept("./online_complaints.vue?vue&type=template&id=b014c45c&scoped=true", function () {
      api.rerender('b014c45c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/complaintreporting/online/online_complaints.vue"
export default component.exports